import React from 'react';
import PropTypes from 'prop-types';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import AppBar from '@material-ui/core/AppBar';
import SwipeableViews from 'react-swipeable-views';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';


import Mode from './Mode';
import Model from './Model';
import Brand from './Brand';
import Combo from './Combo';
import Group from './Group';
import Title from '../title';
import Branch from './Branch';
import Assembly from './Assembly';
import Category from './Category';
import Permission from '../../functions/permission';

function TabContainer({ children, dir }) {
  return (
    <Typography component="div" dir={dir} style={{ padding: 8 * 3 }}>
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
  dir: PropTypes.string.isRequired,
};

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
  },
});

class Addmenu extends React.Component {
  
  state = { value: 0, values: 0, menuPermission: [] };

  componentDidMount() {
    let menuPermission = Permission('add-menu', this.props.menus);
    this.setState({ menuPermission })
  }

  handleChange = (event, value) => { this.setState({ value: value, value1: 'nill' }); };

  handleChange1 = (event, value) => { this.setState({ value1: value, value: 'null' }); };

  handleChangeIndex = index => { this.setState({ value: index }); };

  handleChangeIndex1 = index => { this.setState({ value: index }); };

  onChange(val) { this.setState({ values: val }) }

  render() {
    const { classes, theme } = this.props;
    let branch, model, assembly, group, category, brand, combo, mode;
    if (this.state.values == 0) {
      branch = (<Branch menuPermission={this.state.menuPermission} />);
    }
    if (this.state.values == 1) {
      model = (<Model menuPermission={this.state.menuPermission} />);
    }
    if (this.state.values == 2) {
      assembly = (<Assembly menuPermission={this.state.menuPermission} />);
    }
    if (this.state.values == 3) {
      group = (<Group menuPermission={this.state.menuPermission} />);
    }
    if (this.state.values == 4) {
      category = (<Category menuPermission={this.state.menuPermission} />);
    }
    if (this.state.values == 5) {
      brand = (<Brand menuPermission={this.state.menuPermission} />);
    }
    if (this.state.values == 6) {
      combo = (<Combo menuPermission={this.state.menuPermission} />);
    }
    if (this.state.values == 7) {
      mode = (<Mode menuPermission={this.state.menuPermission} />);
    }

    return (
      <div className={classes.root}>
        <Title title={'Add Menu'} openDrawer={this.props.openDrawer}/>
        { this.state.menuPermission.view ?
          (
            <div>
              <AppBar position="static" color="default">
                <Tabs value={this.state.value} onChange={this.handleChange} indicatorColor="primary"
                  textColor="primary"  variant="fullWidth" >
                  <Tab label="BRANCH" onClick={this.onChange.bind(this, 0)} />
                  <Tab label="MODEL" onClick={this.onChange.bind(this, 1)} />
                  <Tab label="ASSENBLY" onClick={this.onChange.bind(this, 2)} />
                  <Tab label="GROUP" onClick={this.onChange.bind(this, 3)} />
                </Tabs>
              </AppBar>
              <AppBar position="static" color="default">
                <Tabs value={this.state.value1} onChange={this.handleChange1} indicatorColor="primary"
                  textColor="primary"  variant="fullWidth" >
                  <Tab label="CATEGORY" onClick={this.onChange.bind(this, 4)} />
                  <Tab label="Brand" onClick={this.onChange.bind(this, 5)} />
                  <Tab label="Combo" onClick={this.onChange.bind(this, 6)} />
                  <Tab label="Mode" onClick={this.onChange.bind(this, 7)} />
                </Tabs>
              </AppBar>
              <SwipeableViews axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                index={this.state.value} onChangeIndex={this.handleChangeIndex}>
                {branch}{model}{assembly}{group}
              </SwipeableViews>
              <SwipeableViews axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                index={this.state.value1} onChangeIndex={this.handleChangeIndex1}>
                {category}{brand}{combo}{mode}
              </SwipeableViews>
            </div>
          ):
          (
            <div>
              <center>You are not allow to access this menu!!!</center>
            </div>
          )
        }

      </div>
    );
  }
}

Addmenu.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Addmenu);
